import React, { useState, useEffect } from 'react';
import { FileBarChart, Phone, MessageCircle } from 'lucide-react';
import { api, inr } from '../api';

const RANGES = [
  { label: 'Today', days: 1 },
  { label: '7 days', days: 7 },
  { label: '30 days', days: 30 },
  { label: '90 days', days: 90 },
];

export default function AdminReport() {
  const [days, setDays] = useState(7);
  const [report, setReport] = useState(null);

  useEffect(() => {
    api.get(`/admin/report?days=${days}`).then((r) => setReport(r.data));
  }, [days]);

  return (
    <div data-testid="admin-report">
      <div className="flex items-center gap-3 mb-3 flex-wrap">
        <h3 className="font-display font-bold text-lg text-slate-800 flex items-center gap-2"><FileBarChart size={17} className="text-blue-600" /> Agent Report</h3>
        <div className="flex bg-slate-100 border-2 border-slate-200 rounded-full p-0.5">
          {RANGES.map((r) => (
            <button
              key={r.days}
              data-testid={`report-range-${r.days}`}
              onClick={() => setDays(r.days)}
              className={`px-3 py-1 rounded-full text-xs font-bold transition-colors ${days === r.days ? 'bg-blue-600 text-white shadow-sm' : 'text-slate-500 hover:text-slate-800'}`}
            >
              {r.label}
            </button>
          ))}
        </div>
      </div>

      <div className="bg-white border-2 border-slate-200 rounded-xl sticky-shadow overflow-x-auto">
        {!report ? (
          <p className="font-hand text-lg text-slate-400 text-center py-8">Crunching numbers…</p>
        ) : (
          <table className="w-full text-left min-w-[640px]" data-testid="report-table">
            <thead>
              <tr className="border-b-2 border-slate-100">
                {['Agent', 'Leads', 'Won', 'Conv %', 'Calls', 'WhatsApp', 'Orders', 'Revenue'].map((h) => (
                  <th key={h} className="px-3 py-2.5 text-[10px] font-bold uppercase tracking-wider text-slate-400">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {report.agents.map((a) => (
                <tr key={a.id} data-testid={`report-row-${a.id}`} className="border-b border-slate-50 hover:bg-slate-50">
                  <td className="px-3 py-2">
                    <span className="flex items-center gap-2">
                      <span className="w-6 h-6 rounded-full flex items-center justify-center text-[9px] font-extrabold text-slate-800 border border-white shadow-sm shrink-0" style={{ background: a.avatar_color }}>
                        {a.name.split(' ').map((w) => w[0]).join('')}
                      </span>
                      <span className="text-xs font-bold text-slate-900">{a.name}</span>
                    </span>
                  </td>
                  <td className="px-3 py-2 text-xs font-semibold text-slate-700">{a.leads_assigned}</td>
                  <td className="px-3 py-2 text-xs font-semibold text-emerald-700">{a.leads_converted}</td>
                  <td className="px-3 py-2">
                    <span className={`text-xs font-extrabold ${a.conversion_rate >= 20 ? 'text-emerald-600' : a.conversion_rate >= 10 ? 'text-amber-600' : 'text-slate-500'}`}>{a.conversion_rate}%</span>
                  </td>
                  <td className="px-3 py-2 text-xs text-slate-600"><span className="flex items-center gap-1"><Phone size={10} className="text-sky-500" />{a.calls}</span></td>
                  <td className="px-3 py-2 text-xs text-slate-600"><span className="flex items-center gap-1"><MessageCircle size={10} className="text-emerald-500" />{a.whatsapps}</span></td>
                  <td className="px-3 py-2 text-xs font-semibold text-slate-700">{a.orders_created}</td>
                  <td className="px-3 py-2 text-xs font-extrabold text-slate-900">{inr(a.revenue)}</td>
                </tr>
              ))}
              <tr className="bg-slate-900 text-white" data-testid="report-totals-row">
                <td className="px-3 py-2.5 text-xs font-extrabold">Team Total</td>
                <td className="px-3 py-2.5 text-xs font-extrabold">{report.totals.leads_assigned}</td>
                <td className="px-3 py-2.5 text-xs font-extrabold text-emerald-300">{report.totals.leads_converted}</td>
                <td className="px-3 py-2.5 text-xs font-extrabold text-amber-300">{report.totals.conversion_rate}%</td>
                <td className="px-3 py-2.5 text-xs font-extrabold">{report.totals.calls}</td>
                <td className="px-3 py-2.5 text-xs font-extrabold">{report.totals.whatsapps}</td>
                <td className="px-3 py-2.5 text-xs font-extrabold">{report.totals.orders_created}</td>
                <td className="px-3 py-2.5 text-xs font-extrabold">{inr(report.totals.revenue)}</td>
              </tr>
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
